import { heartRunnerprofileSettingsState } from '../state/heartRunnerprofileSettingsState'
import { 
        UPDATE_PASSWORD_SETTINGS_REQUEST, UPDATE_PASSWORD_SETTINGS_SUCCESS, UPDATE_PASSWORD_SETTINGS_ERROR, 
        UPDATE_PROFILE_SETTINGS_REQUEST, UPDATE_PROFILE_SETTINGS_SUCCESS, UPDATE_PROFILE_SETTINGS_ERROR, 
        FETCH_PROFILE_SETTINGS_DETAILS_REQUEST, FETCH_PROFILE_SETTINGS_DETAILS_SUCCESS, FETCH_PROFILE_SETTINGS_DETAILS_ERROR 
       } 
        from '../actions/heartRunnerprofileSettingsAction'
var initialStatusCode='';
export function heartRunnerprofileSettingsReducer(state = heartRunnerprofileSettingsState, action) {
    switch (action.type) {
        case UPDATE_PROFILE_SETTINGS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: initialStatusCode,
                errorMessage: '',

            })
        case UPDATE_PROFILE_SETTINGS_SUCCESS:
            //debugger
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage,
                profileInfo:action.heartRunnerUserDetail,
                statusCode: action.statusCode,
            })
        case UPDATE_PROFILE_SETTINGS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case UPDATE_PASSWORD_SETTINGS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: initialStatusCode

            })
        case FETCH_PROFILE_SETTINGS_DETAILS_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode: initialStatusCode,

            })
            case FETCH_PROFILE_SETTINGS_DETAILS_SUCCESS:
                    
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                profileInfo:action.heartRunnerProfileInfo
                
            })
        case FETCH_PROFILE_SETTINGS_DETAILS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case UPDATE_PASSWORD_SETTINGS_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage,
                statusCode: action.statusCode,
            })
        case UPDATE_PASSWORD_SETTINGS_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        default:
            return state;
    }
}
